module.exports = __webpack_public_path__ + "img/5.b9ef0610.jpg";